import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { Box, Grid, Stack } from '@mui/material';
import FormSection from '@/components/form/form-section';
import useFormHandle from '@/hooks/use-form-handle.hook';
import { useQuery } from 'react-query';
import useQueryHelper from '@/hooks/use-query-helper';
import { PartnerModel } from '@/lib/models/partner.model';
import { getPartner } from '@/lib/services/partner.service';
import { QueryKey } from '@/lib/query-client';
import { Form } from '@/components/form';
import Text from '@/components/text';
import Chip from '@/components/chip';

const fields = ['name', 'domains'];
const formModel = new PartnerModel();

const ProfileForm: FC = () => {
  const formHandle = useFormHandle({
    initialValues: formModel,
    validationSchema: formModel.schemaSlice(fields),
    onSubmit: () => {
      return;
    },
  });

  const query = useQuery([QueryKey.PartnerProfile], async () => getPartner());
  const { showLoader } = useQueryHelper(query);
  const { data: partner } = query;

  if (showLoader) {
    return null;
  }

  return (
    <Box>
      <Box mb={4}>
        <Form formHandle={formHandle} query={query}>
          <FormSection title="Profile Settings">
            <Grid container spacing={6}>
              <Grid item xs={6}>
                <InputControl name="name" label="Partner Name" formHandle={formHandle} readonly />
              </Grid>
              <Grid item xs={6}>
                <Box mb={1}>
                  <Text bold>Domains:</Text>
                </Box>
                <Stack direction="row" gap={0.5}>
                  {partner?.domains.map((domain) => <Chip key={domain} label={domain} />)}
                </Stack>
              </Grid>
            </Grid>
          </FormSection>
        </Form>
      </Box>
    </Box>
  );
};

export default ProfileForm;
